import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TelephoneModalContent = ({ telephoneField }) => {
    const { t } = useTranslation();
    const { telephoneFieldValue, setTelephoneFieldValue } = telephoneField;
    const handleChange = (e) => {
        let value = e.target.value;
        // Replace any invalid characters with an empty string
        value = value.replace(/^[0|\D]*/, '');
        value = value.replace(' ', '');

        setTelephoneFieldValue(value);
    };

    return (
        <Box display='flex' flexDirection='column' gap='8px' width='full' height={'min-content'}>
            <Typography variant='body1'>{t('telephone.inputs.modify')}</Typography>
            <TextField
                id="outlined-read-only-input"
                label="+549"
                value= {telephoneFieldValue}
                variant="outlined"
                inputMode="telephone"
                size="small"
                inputProps={{ maxLength: 10 }}
                onChange={handleChange}
                sx={{
                    '& .MuiInputBase-root': {
                        height: '35px',
                        backgroundColor: 'white',
                    },
                    '& .MuiInputLabel-root': {
                        lineHeight: '10px'
                    },
                }}
            />
        </Box>
    );
};

export default TelephoneModalContent;
